package com.jingfangpai.signSymptom.model

import com.jingfangpai.common.orm.mapping.SignSymptom
import com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomDetail:SignSymptom() {
    var characteristics:Array<SignSymptomCharacteristic> = arrayOf()
    var categoryOthers:Array<SignSymptom> = arrayOf()
}